import React, {memo} from 'react';
import MUIBox from '@/components/MUI-Components/MUI-Box';
import MUITypography from '@/components/MUI-Components/MUI-Typography';
import {borderRadius, fontFamily, fontSize, fontWeight, spacing} from '@/styles/tokens';

// Migrated from globals.scss `.security_heading`.
const sxSecurityHeading = {
    fontFamily: fontFamily.heading,
    fontSize: fontSize[42],
    fontWeight: fontWeight.bold,
    textAlign: 'center'
};

// Migrated from globals.scss `.security_content_wrapper` (+ its `li` descendant rule).
// Background color kept literal — no colors.* token reproduces this exact tint.
const sxSecurityContentWrapper = {
    backgroundColor: '#e0eaff',
    padding: `${spacing[20]} ${spacing[40]}`,
    borderRadius: borderRadius[14],
    '& li': {
        fontFamily: fontFamily.body,
        fontSize: fontSize[16],
        fontWeight: fontWeight.regular,
        marginTop: '10px' // no exact spacing-token match
    }
};

const SoftwareSecurity = (props: any) => {
    const {heading, subheading} = props;
    return (
        <>
            <MUIBox className="security_head_wrapper top-space">
                <MUITypography className="color-black" sx={sxSecurityHeading}>
                    {heading}
                </MUITypography>
                <MUIBox className="divder-wrapper">
                    <hr className="divider-line" />
                </MUIBox>
                <MUIBox className="sub-heading-box">
                    <MUITypography className="sub-heading color-black spacing">{subheading}</MUITypography>
                </MUIBox>
            </MUIBox>
            <MUIBox component="ul" sx={sxSecurityContentWrapper}>
                <li> Having a profound knowledge of health information privacy standards- HIPAA, GDPR, HITECH</li>
                <li>Compliance with ISO 9001, ISO27001, and SOC2 certifications.</li>
                <li> Experience in healthcare software development standards- HL7, FHIR, CDA, DICOM, ICD, ICPC-2</li>
            </MUIBox>
        </>
    );
};

export default memo(SoftwareSecurity);
